import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { ReportsApi, type AuditEntry } from "./api";

export function AuditLog() {
  const [actor, setActor] = useState("");
  const [action, setAction] = useState("");
  const [targetType, setTargetType] = useState("");

  const filters = { actor, action, targetType, limit: 200 };
  const log = useQuery({
    queryKey: ["audit-log", actor, action, targetType],
    queryFn: () => ReportsApi.auditLog(filters),
  });

  return (
    <div className="hierarchy">
      <header>
        <h1>Audit log</h1>
        <p className="muted">Every privileged action against the platform. Append-only.</p>
      </header>

      <div className="row-3" style={{ marginBottom: 12 }}>
        <input value={actor} onChange={(e) => setActor(e.target.value)} placeholder="Actor uid" />
        <input value={action} onChange={(e) => setAction(e.target.value)} placeholder="Action (e.g. delete, export)" />
        <input value={targetType} onChange={(e) => setTargetType(e.target.value)} placeholder="Target type (case, role, …)" />
      </div>

      {log.isLoading && <p>Loading…</p>}
      {log.error && <p className="error">{(log.error as Error).message}</p>}

      <table className="audit-table">
        <thead>
          <tr>
            <th>Time (UTC)</th>
            <th>Actor</th>
            <th>Action</th>
            <th>Target</th>
            <th>IP</th>
          </tr>
        </thead>
        <tbody>
          {log.data?.items.map((e: AuditEntry) => (
            <tr key={e.id}>
              <td><code>{e.at}</code></td>
              <td>{e.actorEmail || e.actorUid || "—"}</td>
              <td><span className="action-tag">{e.action}</span></td>
              <td><span className="muted">{e.targetType}</span> {e.targetId}</td>
              <td className="muted">{e.ip || "—"}</td>
            </tr>
          ))}
          {log.data?.items.length === 0 && (
            <tr><td colSpan={5} className="muted" style={{ padding: 12 }}>No matching entries.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
